import { networks } from "./config";

export const getNetworkUrl = (networkId: any) => {
    const currentNetwork = networks.find(
        (item: any) => item.id === networkId
    ) || {
        url: "",
    };
    return currentNetwork.url;
};